import { defineMessages } from 'react-intl'

const scope = `procurify.spending-cards.presenter.GetDetailedCardPresenter`

export default defineMessages({
  errorFetchingCardToastTitle: {
    id: `${scope}.errorFetchingCardToastTitle`,
    defaultMessage: 'Error fetching card',
  },
})
